import styled from 'styled-components';

import Button from '@components/Button';
import { Row } from '@components/formStyles';

export const StyledButton = styled(Button)<{ isSelected: boolean }>`
  width: 104px;
  height: 40px !important;
  font-weight: 600;
  font-size: 14px !important;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: flex;
    font-size: 14px !important;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 16px;
  }

  ${({ isSelected, theme }) =>
    isSelected &&
    `border-color: ${theme.palette.greenSuccess} !important;
    color: ${theme.palette.greenSuccess} !important;
    background-color: ${theme.palette.white} !important;
    pointer-events: none !important; `}/* &:hover {
    background-color: ${({ theme }) => theme.palette.primaryBrand} !important;
  } */
`;

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  margin-top: 24px;
  padding: 24px 16px;
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.palette.grey300};
  background-color: ${({ theme }) => theme.palette.white};
  position: relative;
`;

export const Title = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.grey1100};
`;

export const Description = styled.span<{ light?: boolean }>`
  font-size: 12px;
  color: ${({ theme, light }) =>
    light ? theme.palette.grey800 : theme.palette.grey1100};
  margin-bottom: 4px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 265px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const GuestInformation = styled.span`
  font-size: 10px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.grey800};
  margin-bottom: 8px;
`;

export const Date = styled.span`
  width: 258px;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const WarningWrapper = styled.div`
  margin-bottom: 15px;
  white-space: normal;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 17px;
    width: 100%;
  }
`;

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 4px;
  margin: 8px 0px;

  & > :first-child > :first-child {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
`;

export const PeopleNightCountWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
export const PeopleNightCount = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.darkGrey};
  white-space: nowrap;
  opacity: 0.75;
  line-height: 14px;
`;

export const AvailableDatesWrapper = styled.div`
  margin-top: auto;
`;

export const DynamicRow = styled(Row)`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
  }
`;
